"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEstimatedDailySwapFee = void 0;
const big_1 = __importDefault(require("@swyftx/big"));
const DAYS_IN_YEAR = 360; // 360 days are used to cater for public holidays (this should not change)
/**
 * @param lotSize - The amount of lots being purchased
 * @param contractSize  - The markets contract size
 * @param currentPrice - The current price of the market
 * @param swapRate - The swap rate in whole number. i.e 8% should be 8
 * @returns - The estimated daily swap fee
 */
const getEstimatedDailySwapFee = (lotSize, contractSize, currentPrice, swapRate) => {
    const lotsPrice = (0, big_1.default)(lotSize).times(contractSize).times(currentPrice);
    const swapChargePercent = (0, big_1.default)(swapRate).div(100);
    const annualSwapCharge = (0, big_1.default)(lotsPrice).times(swapChargePercent);
    return annualSwapCharge.div(DAYS_IN_YEAR);
};
exports.getEstimatedDailySwapFee = getEstimatedDailySwapFee;
//# sourceMappingURL=swapFees.js.map